import { Filial } from '../types';

export const getBalloon = ({ contacts, name }: Filial) => {
  const { address, email, phone } = contacts; 
  const footer = [email, phone].filter(item => !!item).join(', ');

  return {
    footer,
    header: name,
    body: address,
  }
}

export const getCoords = ({ coords }: Filial) => {
  if (!coords) return [null, null];
  const { latitude, longitude } = coords;
  return [
    typeof latitude === 'string' ? parseFloat(latitude) : latitude,
    typeof longitude === 'string' ? parseFloat(longitude) : longitude,
  ];
}

export const getMarker = (item: Filial) => ({
  address: item.contacts.address,
  balloon: getBalloon(item),
  coords: getCoords(item),
  contacts: item.contacts,
  name: item.name,
});

export default getMarker;



// WEBPACK FOOTER //
// ./src/pages/organizations/card/map/tools.ts